import { Map } from 'immutable'
import { createSelector } from 'reselect'
const root = state => state.get('classification')

export const classifications = state => root(state).get('classifications')

const status = state => root(state).get('status')
export const isLoading = state => status(state).get('loading', false)
export const isLoaded = state => status(state).get('loaded', false)

export const classificationOptions = createSelector(classifications, classifications => {
  return classifications
    .map(classification => ({ label: classification.name, value: classification.id }))
    .toJS()
})

export const classificationListOptions = createSelector(classifications, classifications => {
  return classifications
    .map(classification => ({ id: classification.id, color: 'EFEEFC', status: 'ENABLED', name: classification.name }))
    .reduce((result, classification) => result.set(classification.id, classification), Map())
})



// WEBPACK FOOTER //
// ./src/scripts/app/modules/classification/selectors.js